import { target, targetable } from '@github/catalyst/lib/targetable'

export default targetable(class extends HTMLElement {
  static [target.static] = ['current', 'password', 'confirmation', 'button']

  connectedCallback () {
    this.current.addEventListener('input', () => this.checkShowButton())
    this.password.addEventListener('input', () => {
      this.checkShowButton()
      this.checkMatch()
    })
    if (this.confirmation) {
      this.confirmation.addEventListener('input', () => {
        this.checkShowButton()
        this.checkMatch()
      })
    }
  }

  checkShowButton () {
    const hasValue = this.current.value.length > 0 ||
                     this.password.value.length > 0 ||
                     (this.confirmation && this.confirmation.value.length > 0)

    if (hasValue) {
      this.button.classList.remove('hidden')
    } else {
      this.button.classList.add('hidden')
    }
  }

  checkMatch () {
    const pwd = this.password.value
    const confirm = this.confirmation ? this.confirmation.value : ''
    const msgEl = this.querySelector('[data-password-match-message]')

    if (!msgEl || !this.confirmation) return

    // Only show message when user has started typing in confirmation field
    if (confirm.length === 0) {
      msgEl.classList.add('hidden')
      return
    }

    msgEl.classList.remove('hidden')

    if (pwd === confirm) {
      msgEl.textContent = 'Passwords match'
      msgEl.classList.remove('text-[#dc2626]')
      msgEl.classList.add('text-green-600')
    } else {
      msgEl.textContent = 'Passwords do not match'
      msgEl.classList.remove('text-green-600')
      msgEl.classList.add('text-[#dc2626]')
    }
  }
})
